<template>
  <a
    class="ai-yuigon-banner"
    href="https://legacy.ne.jp/forCustomer/ai-yuigon-well-b"
    target="_blank"
    rel="noopener noreferrer"
  >
    <picture>
      <source media="(max-width: 768px)" :srcset="bannerSp">
      <img class="ai-yuigon-banner-image" :src="bannerPc" alt="AIユイゴン Well-B">
    </picture>
  </a>
</template>

<script>
// AIユイゴン Well-B cross-link banner. Links to the sister service; artwork supplied
// by the client (see reference_docs/frontend_mockups/AIユイゴン連携バナー_制作仕様書.md).
import bannerPc from '@/images/banner/aiyuigon/aiyuigon-banner-pc.svg'
import bannerSp from '@/images/banner/aiyuigon/aiyuigon-banner-sp.svg'

export default {
  name: 'ai-yuigon-banner-placeholder',
  data () {
    return {
      bannerPc,
      bannerSp
    }
  }
}
</script>

<style scoped>
.ai-yuigon-banner {
  display: block;
  margin-bottom: 15px;
}

.ai-yuigon-banner-image {
  display: block;
  width: 100%;
  height: auto;
}
</style>
